var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesignPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.21128 9.66001L2.03806 13.0928C1.85422 13.6307 2.3677 14.1455 2.90537 13.9623L6.33939 12.7925C6.63662 12.6912 6.90667 12.523 7.12873 12.3008L7.23315 12.1963C7.36671 12.0627 7.36673 11.846 7.2332 11.7123L4.29086 8.76699C4.15735 8.63335 3.94091 8.63333 3.80738 8.76694L3.70197 8.8724C3.48049 9.09401 3.31264 9.36343 3.21128 9.66001Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90334 4.76831C8.76705 4.63251 8.54594 4.63295 8.4102 4.7693L5.4343 7.75848C5.29935 7.89404 5.29979 8.11281 5.43529 8.24783L8.43008 11.2319C8.56637 11.3677 8.78748 11.3672 8.92322 11.2309L11.8991 8.24168C12.0341 8.10612 12.0336 7.88735 11.8981 7.75233L8.90334 4.76831Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9589 2.60302L9.43386 3.12808C9.29988 3.26208 9.29988 3.47931 9.43387 3.6133L12.3867 6.56617C12.5207 6.70017 12.7379 6.70017 12.8719 6.56616L13.3971 6.04095C14.201 5.237 14.201 3.9336 13.3971 3.12967L12.8704 2.603C12.0664 1.79899 10.7629 1.799 9.9589 2.60302Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignPencil);
export default __webpack_public_path__ + "static/media/design-pencil.aea3a4b8.svg";
export { ForwardRef as ReactComponent };